import { createBaseNotary, type IBaseNotary } from "../BaseNotaryFactory";
import type { OfficeRole } from "le-coffre-resources/dist/Notary";
import type { QueryPayload } from "../../../types";
import type { IGetOfficeRolesParams } from "./OfficeRoles";

interface OfficeRolesInstance {
	get(q?: IGetOfficeRolesParams): Promise<OfficeRole[]>;
	getByUid(uid: string, q?: QueryPayload): Promise<OfficeRole>;
}

let instance: OfficeRolesInstance | null = null;
let baseNotaryInstance: IBaseNotary | null = null;

function createOfficeRoles(): OfficeRolesInstance {
	if (!baseNotaryInstance) {
		baseNotaryInstance = createBaseNotary();
	}

	const baseNotary = baseNotaryInstance;
	const baseUrl = baseNotary.namespaceUrl.concat("/office-roles");

	return {
		get: async (q?: IGetOfficeRolesParams): Promise<OfficeRole[]> => {
			const url = new URL(baseUrl);
			if (q) {
				baseNotary.appendJsonSearchParams(url, { q });
			}
			try {
				return await baseNotary.getRequest<OfficeRole[]>(url);
			} catch (err) {
				baseNotary.onError(err);
				return Promise.reject(err);
			}
		},
		getByUid: async (uid: string, q?: QueryPayload): Promise<OfficeRole> => {
			const url = new URL(baseUrl.concat("/").concat(uid));
			if (q) {
				baseNotary.appendJsonSearchParams(url, q);
			}
			try {
				return await baseNotary.getRequest<OfficeRole>(url);
			} catch (err) {
				baseNotary.onError(err);
				return Promise.reject(err);
			}
		},
	};
}

export function getOfficeRolesInstance(): OfficeRolesInstance {
	if (!instance) {
		instance = createOfficeRoles();
	}
	return instance;
}
